export const SAVE_KANBAN = "x/config/advanced/SAVE_KANBAN";
export const saveKanban = data => ({
    type: SAVE_KANBAN,
    payload: data,
});
